export enum ScenarioStatus {
  Positive = 'success',
  Negative = 'error',
  Neutral = 'none',
}

export enum StatusIndicator {
  Danger = 'danger',
}
